import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoCardsB from 'eco-design/sections-test/eco-cards-b';
import EcoShopCardA from 'eco-design/sections-test/eco-shop-card-a';
import styles from './index.module.scss';
export default function Comp() {
    const { t } = useLang('theProduct.ListB3');
    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745207624566/KV.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745207767634/KV.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745373184405/KSP1%20(3).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745207768546/KSP1-%E6%91%84%E6%B0%8F%E5%BA%A6.jpg',
            desc: t('item1_desc1'),
            title: t('item1_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745373184535/KSP1%20(4).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745207768121/KSP1.jpg',
            desc: t('item2_desc1'),
            title: t('item2_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745373184722/KSP1%20(5).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745207767834/Frame%201612707476.jpg',
            desc: t('item3_desc1'),
            title: t('item3_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745373183029/image%20(4).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745207768329/KSP1%20(1).jpg',
            desc: t('item4_desc1'),
            title: t('item4_title'),
        },
    ];
    return (
        <>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <div className={`${styles.comp}`}>
                <EcoCardsB items={itemsA} />
                <div className={`eco-content`}>
                    <EcoShopCardA
                        layout="imgR"
                        pc="https://websiteoss.ecoflow.com/upload/image/1745204810377/500W.png"
                        title={t('card_title')}
                        desc={[t('card_desc1'), t('card_desc2'), t('card_desc3')]}
                        lChildren={t('card_btn')}
                        lHref={'https://jp.ecoflow.com/products/ecoflow-500w-alternator-charger'}
                        ldataLayer={{
                            event: 'uaEvent',
                            event_name: 'buy',
                            product_name: t('card_title'),
                            position: `Collections_${t('card_title')}`,
                        }}
                    />
                </div>
            </div>
        </>
    );
}
